<script setup>
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const page = usePage()
const partnersBase = computed(() => page.props.partners_base || '/partners')
</script>

<template>
  <p class="lyb">
    {{ t('public.footer.own_a_business') }}
    <a :href="partnersBase" class="lyb__link">{{ t('public.footer.list_your_business') }}</a>
  </p>
</template>

<style scoped>
.lyb { text-align: center; font-size: 0.9rem; color: var(--muted, #667085); margin: 2rem 0 0; }
.lyb__link { text-decoration: underline; color: inherit; }
</style>
